<!-- https://github.com/vuejs/vue-router/issues/1280#issuecomment-358773490 -->

<template>
  <component v-bind="linkProps(to)">
    <slot></slot>
  </component>
</template>

<script>
  export default {
    props: {
      to: {
        type: String,
        required: true
      }
    },
    methods: {
      linkProps (url) {
        if (url.match(/^(http(s)?|ftp):\/\//)) {
          return {
            is: 'a',
            href: url,
            target: '_blank',
            rel: 'noopener'
          }
        }
        return {
          is: 'router-link',
          to: url
        }
      }
    }
  }
</script>

<style scoped lang="scss">
a {
  color: inherit;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/WorkLink.vue